import './index.css';

function Select(props) {
  return (
    <div className='SelectContainer'>
      <select {...props} className='Select'>
        <option value="" disabled selected>{props.placeholder || ""}</option>
        {
          props.options.map((option) => {
            return (
              <option>{option.name}</option>
            )
          })
        }
      </select>
    </div>
  )
}

export { Select };
